document.addEventListener("DOMContentLoaded", () => {
  const hasVariantInUrl = new URLSearchParams(window.location.search).has("variant");

// Only auto-select the first variant if NO variant is specified
if (!hasVariantInUrl) {
  setTimeout(() => {
    const radios = document.querySelectorAll(
      'input[type="radio"][name]'
    );

    if (radios.length > 0) {
      radios[0].click();
    }
  }, 100);
}

  const preorderButton = document.getElementById("preorder-button");
  const preorderModal = document.getElementById("preorder-modal");
  const dateInput = document.getElementById("preorder-date");
  const confirmButton = document.getElementById("confirm-preorder");

  if (!preorderButton || !preorderModal || !dateInput || !confirmButton) {
    return;
  }

  // Close button
  let closeButton = preorderModal.querySelector(".preorder-close");

  if (!closeButton) {
    closeButton = document.createElement("button");
    closeButton.type = "button";
    closeButton.className = "preorder-close";
    closeButton.innerHTML = "&times;";
    preorderModal.prepend(closeButton);
  }

  let calendarInitialized = false;

  preorderButton.addEventListener("click", () => {
    preorderModal.removeAttribute("hidden");

    if (!calendarInitialized) {
      flatpickr(dateInput, {
  disable: window.blockedPreorderDates || [],
  dateFormat: "Y-m-d",
  minDate: "today",
  allowInput: false,
  static: true
});

      calendarInitialized = true;
    }
  });

  // Close modal
  closeButton.addEventListener("click", () => {
    preorderModal.setAttribute("hidden", "");
  });

  // Close when clicking outside
  document.addEventListener("click", (event) => {
    if (
      !preorderModal.hasAttribute("hidden") &&
      !preorderModal.contains(event.target) &&
      event.target !== preorderButton
    ) {
      preorderModal.setAttribute("hidden", "");
    }
  });

  // Confirm Pre-order
  confirmButton.addEventListener("click", async () => {

    if (!dateInput.value) {
      alert("Please select a shipping date.");
      return;
    }

    // Dawn product form
    const productForm = document.querySelector('product-form form');

    if (!productForm) {
      alert("Product form not found.");
      return;
    }

    const formData = new FormData(productForm);

    const variantId = formData.get("id");

    console.log("Variant ID:", variantId);
    console.log("Shipping Date:", dateInput.value);

    if (!variantId) {
      alert("Variant not found.");
      return;
    }

    try {

      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({
          id: Number(variantId),
          quantity: 1,
          properties: {
            "Order Type": "Pre-order",
            "Shipping Date": dateInput.value
          }
        })
      });

      const result = await response.json();

      console.log(result);

      if (!response.ok) {
        throw new Error(result.description || "Unable to add product.");
      }

      preorderModal.setAttribute("hidden", "");

      // Temporary - redirect to cart
      window.location.href = "/cart";

    } catch (error) {
      console.error(error);
      alert(error.message);
    }

  });

   // Existing confirm preorder code...

  // Run on page load
const observer = new MutationObserver(() => {
  togglePreorderButton();
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});

// Run once immediately
setTimeout(togglePreorderButton, 200);

});

function togglePreorderButton() {

  const preorderButton = document.getElementById("preorder-button");
  const addToCartButton = document.querySelector(".product-form__submit");
  const notifyButton = document.querySelector(".nm-portal");

  //const variantInput = document.querySelector('input[name="id"]');
  const variantInput = document.querySelector(
  'product-form input[name="id"]'
);

  if (!preorderButton || !variantInput) return;

  const selectedVariantId = Number(variantInput.value);

  if (selectedVariantId === Number(window.preorderVariantId)) {

    // Pre-Order variant selected
    preorderButton.style.display = "block";

    if (addToCartButton) {
      addToCartButton.style.display = "none";
    }

    if (notifyButton) {
      notifyButton.style.display = "none";
    }

  } else {

    // Ships Now variant selected
    preorderButton.style.display = "none";

    if (addToCartButton) {
      addToCartButton.style.display = "";
    }

    if (notifyButton) {
      notifyButton.style.display = "";
    }

  }
}